/*
  Luvari filter panel (web_dev 2026-11-04; cro spec claude/luvari-req-web_dev-filter-panel-v1.md).
  Replaces Dawn's facets.js on collection and search pages. One panel (snippets/facets.liquid):
  sidebar at 990 px and up, drawer below. Live results: each change fetches the section once
  (Section Rendering API), as before, and swaps the grid, counts, chips and filter sections.
  Keeps #ProductGridContainer / #product-grid for tracking (luvari-tracking-collection) and
  infinite-scroll.js. No new requests beyond that one fetch.
*/
(function () {
  if (customElements.get('luv-filters')) return;

  var DEBOUNCE = 800; // same as Dawn's facets.js
  var DRAWER = window.matchMedia('(max-width: 989px)');

  // Size the Sort box to the chosen option so Filter, Sort and the count share one row on phones
  // (cro polish 11-04). Browsers with CSS field-sizing do this in CSS; others get this fallback.
  var fitCanvas = null;
  function fitSort() {
    var s = document.getElementById('LuvSort');
    if (!s) return;
    if (window.CSS && CSS.supports && CSS.supports('field-sizing', 'content')) return;
    try {
      var cs = getComputedStyle(s);
      fitCanvas = fitCanvas || document.createElement('canvas').getContext('2d');
      fitCanvas.font = cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
      var opt = s.options[s.selectedIndex];
      var w = fitCanvas.measureText(opt ? opt.text : '').width;
      s.style.width = Math.ceil(w + parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight) + 4) + 'px';
    } catch (e) {}
  }

  function headerOffset() {
    var v = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
    return isNaN(v) ? 0 : v;
  }

  class LuvFilters extends HTMLElement {
    connectedCallback() {
      this.section = this.dataset.section;
      this.panel = this.querySelector('#LuvFilterPanel');
      this.cache = {};
      this.seq = 0;
      this.timer = null;
      this.lastQS = location.search.slice(1);

      if (DRAWER.matches) this.closeSections();

      var self = this;
      this.addEventListener('change', function (e) {
        var t = e.target;
        if (t.matches('[data-luv-price]')) { self.submit(0); return; }
        if (t.matches('input[type="checkbox"]')) self.submit(DEBOUNCE);
      });
      this.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-luv-price]')) {
          e.preventDefault();
          self.submit(0);
        }
      });
      this.addEventListener('submit', function (e) { e.preventDefault(); self.submit(0); });

      document.addEventListener('change', function (e) {
        if (e.target && e.target.id === 'LuvSort') { fitSort(); self.submit(0); }
      });
      fitSort();

      document.addEventListener('click', function (e) {
        var t = e.target.closest('[data-luv-open],[data-luv-close],[data-luv-done],[data-luv-clear],[data-luv-link],[data-luv-more]');
        if (!t) return;
        if (t.hasAttribute('data-luv-open')) { e.preventDefault(); self.open(); }
        else if (t.hasAttribute('data-luv-close') || t.hasAttribute('data-luv-done')) { e.preventDefault(); self.close(true); }
        else if (t.hasAttribute('data-luv-clear')) { e.preventDefault(); self.go(self.dataset.clear); }
        else if (t.hasAttribute('data-luv-link')) { e.preventDefault(); self.go(t.getAttribute('href')); }
        else if (t.hasAttribute('data-luv-more')) {
          e.preventDefault();
          self.expand(t.closest('.luv-f'), t.getAttribute('aria-expanded') !== 'true');
        }
      });

      document.addEventListener('keydown', function (e) {
        if (!self.classList.contains('is-open')) return;
        if (e.key === 'Escape') { e.preventDefault(); self.close(true); return; }
        if (e.key === 'Tab') self.trap(e);
      });

      window.addEventListener('popstate', function () {
        var qs = location.search.slice(1);
        if (qs === self.lastQS) return;
        self.syncSort(qs);
        self.render(qs, false);
      });

      var onMQ = function () { if (!DRAWER.matches) self.close(false); };
      if (DRAWER.addEventListener) DRAWER.addEventListener('change', onMQ);
      else if (DRAWER.addListener) DRAWER.addListener(onMQ);
    }

    /* ---------- state ---------- */
    params() {
      var p = new URLSearchParams();
      var form = this.querySelector('[data-luv-form]');
      if (form) {
        new FormData(form).forEach(function (v, k) {
          if (typeof v === 'string' && v.trim() === '') return;
          p.append(k, typeof v === 'string' ? v.trim() : v);
        });
      }
      var sort = document.getElementById('LuvSort');
      if (sort && sort.value && sort.value !== sort.getAttribute('data-default')) p.set('sort_by', sort.value);
      return p.toString();
    }

    submit(delay) {
      var self = this;
      clearTimeout(this.timer);
      this.setLoading(true);
      this.timer = setTimeout(function () { self.render(self.params(), true); }, delay);
    }

    go(href) {
      var qs = '';
      try { qs = new URL(href, location.href).search.slice(1); } catch (e) {}
      qs = qs.split('&').filter(function (kv) { return kv && !/^page=/.test(kv); }).join('&');
      // Clear all and chip removal keep the shopper's sort.
      var sort = document.getElementById('LuvSort');
      if (sort && sort.value && sort.value !== sort.getAttribute('data-default') && !/(^|&)sort_by=/.test(qs)) qs = (qs ? qs + '&' : '') + 'sort_by=' + encodeURIComponent(sort.value);
      // Chip links from Shopify carry the default sort; drop it so addresses stay clean.
      if (sort) {
        var def = sort.getAttribute('data-default');
        qs = qs.split('&').filter(function (kv) { return kv !== 'sort_by=' + def; }).join('&');
      }
      this.syncSort(qs);
      clearTimeout(this.timer);
      this.render(qs, true);
    }

    syncSort(qs) {
      var sort = document.getElementById('LuvSort');
      if (!sort) return;
      var v = new URLSearchParams(qs).get('sort_by') || sort.getAttribute('data-default');
      if (v && sort.value !== v) {
        for (var i = 0; i < sort.options.length; i++) if (sort.options[i].value === v) { sort.value = v; break; }
      }
      fitSort();
    }

    setLoading(on) {
      document.documentElement.classList.toggle('luv-filters-loading', on);
      var grid = document.querySelector('#ProductGridContainer .collection');
      if (grid) grid.classList.toggle('loading', on);
      var done = this.querySelector('[data-luv-done]');
      if (done) { if (on) done.setAttribute('aria-busy', 'true'); else done.removeAttribute('aria-busy'); }
    }

    render(qs, push) {
      var self = this;
      var seq = ++this.seq;
      this.lastQS = qs;
      if (push) history.pushState({ luvFilters: qs }, '', location.pathname + (qs ? '?' + qs : ''));
      this.setLoading(true);
      var url = location.pathname + '?section_id=' + encodeURIComponent(this.section) + (qs ? '&' + qs : '');
      var cached = this.cache[url];
      var p = cached ? Promise.resolve(cached) : fetch(url, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      });
      p.then(function (html) {
        self.cache[url] = html;
        if (seq !== self.seq) return;
        self.apply(new DOMParser().parseFromString(html, 'text/html'));
        self.setLoading(false);
      }).catch(function () {
        if (seq !== self.seq) return;
        location.assign(location.pathname + (qs ? '?' + qs : ''));
      });
    }

    apply(doc) {
      var focusId = document.activeElement && this.contains(document.activeElement) ? document.activeElement.id : '';

      // Grid (tracking and infinite scroll watch this container).
      var g = doc.getElementById('ProductGridContainer');
      var G = document.getElementById('ProductGridContainer');
      if (g && G) {
        G.innerHTML = g.innerHTML;
        G.querySelectorAll('.scroll-trigger').forEach(function (el) { el.classList.add('scroll-trigger--cancel'); });
      }

      // Counts, opener, chips (toolbar and drawer).
      ['[data-luv-count]', '[data-luv-opener]', '[data-luv-chips]'].forEach(function (sel) {
        var src = doc.querySelector(sel);
        if (!src) return;
        document.querySelectorAll(sel).forEach(function (el) {
          el.innerHTML = src.innerHTML;
          el.hidden = src.hidden;
        });
      });
      var o = doc.querySelector('[data-luv-open]');
      document.querySelectorAll('[data-luv-open]').forEach(function (el) { if (o) el.hidden = o.hidden; });

      // Filter sections: keep what the shopper opened or expanded.
      var S = this.querySelector('[data-luv-sections]');
      var s = doc.querySelector('[data-luv-sections]');
      if (S && s) {
        var self = this;
        s.querySelectorAll('.luv-f').forEach(function (n) {
          var cur = document.getElementById(n.id);
          if (n.matches('details')) {
            if (cur && cur.matches('details')) n.open = cur.open;
            else if (DRAWER.matches) n.open = false;
          }
          var btn = cur && cur.querySelector('[data-luv-more][aria-expanded="true"]');
          if (btn) self.expand(n, true);
        });
        S.replaceChildren.apply(S, Array.prototype.slice.call(s.childNodes).map(function (n) { return document.adoptNode(n); }));
      }

      // Footer.
      ['[data-luv-done]', '[data-luv-clear]'].forEach(function (sel) {
        var a = doc.querySelector(sel);
        var b = this.querySelector(sel);
        if (a && b) { b.textContent = a.textContent; b.disabled = a.disabled; }
      }, this);

      // Announce the new count.
      var live = this.querySelector('[data-luv-live]');
      var src = doc.querySelector('[data-luv-live]');
      if (live && src) {
        live.textContent = '';
        var text = src.getAttribute('data-text');
        setTimeout(function () { live.textContent = text; }, 50);
      }

      if (focusId) {
        var el = document.getElementById(focusId);
        if (el) el.focus({ preventScroll: true });
      }
      document.dispatchEvent(new CustomEvent('luv:filters-updated'));
    }

    /* ---------- sections ---------- */
    closeSections() {
      this.querySelectorAll('details[data-luv-section]').forEach(function (d) { d.open = false; });
    }

    expand(section, on) {
      if (!section) return;
      section.querySelectorAll('[data-luv-extra]').forEach(function (li) { li.hidden = !on; });
      var btn = section.querySelector('[data-luv-more]');
      if (!btn) return;
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      btn.textContent = on ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
      btn.setAttribute('aria-label', on ? btn.getAttribute('data-less-aria') : btn.getAttribute('data-more-aria'));
    }

    /* ---------- drawer ---------- */
    open() {
      if (!DRAWER.matches || this.classList.contains('is-open')) return;
      this.classList.add('is-open');
      document.body.classList.add('luv-filters-open');
      this.panel.setAttribute('role', 'dialog');
      this.panel.setAttribute('aria-modal', 'true');
      document.querySelectorAll('[data-luv-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var title = this.querySelector('#LuvFilterTitle');
      requestAnimationFrame(function () { if (title) title.focus({ preventScroll: true }); });
    }

    close(scroll) {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      document.body.classList.remove('luv-filters-open');
      this.panel.removeAttribute('role');
      this.panel.removeAttribute('aria-modal');
      var opener = document.querySelector('[data-luv-open]');
      document.querySelectorAll('[data-luv-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (scroll) {
        var bar = document.getElementById('LuvFilterToolbar');
        var anchor = bar && bar.parentElement;
        if (anchor) {
          var y = anchor.getBoundingClientRect().top + window.scrollY - headerOffset();
          window.scrollTo({ top: Math.max(0, y) });
        }
      }
      if (opener) opener.focus({ preventScroll: true });
    }

    trap(e) {
      var nodes = Array.prototype.filter.call(
        this.panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,summary,[tabindex]:not([tabindex="-1"])'),
        function (n) { return n.offsetParent !== null || n === document.activeElement; }
      );
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      var inside = this.panel.contains(document.activeElement);
      if (e.shiftKey && (document.activeElement === first || !inside || document.activeElement.id === 'LuvFilterTitle')) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && (document.activeElement === last || !inside)) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  customElements.define('luv-filters', LuvFilters);
})();
